import './App.css';
import VideoPlayer from "./VideoPlayer";

export default function App() {
  return (
    <div className="App">
      <VideoPlayer />
    </div>
  );
}
